import React from 'react'
import { Flex, Span } from '@fareye/ui'

function FieldValue({ style, label, value, labelStyle, valueStyle }: any) {
  return (
    <Flex
      alignItemsFlexEnd
      style={{
        justifyContent: label ? 'space-between' : 'flex-start',
        ...style
      }}
    >
      {label && (
        <Span style={{ color: 'inherit', ...labelStyle }}>{label}&nbsp;</Span>
      )}
      {value ? (
        <Span style={{ color: 'inherit', ...valueStyle }}>{value}</Span>
      ) : (
        <Span style={{ color: 'inherit' }}>&nbsp;</Span>
      )}
    </Flex>
  )
}

export default FieldValue
